import { render, staticRenderFns } from "./CountriesLanguagesSidebar.vue?vue&type=template&id=3f55f95e"
import script from "./CountriesLanguagesSidebar.vue?vue&type=script&lang=js"
export * from "./CountriesLanguagesSidebar.vue?vue&type=script&lang=js"
import style0 from "./CountriesLanguagesSidebar.vue?vue&type=style&index=0&id=3f55f95e&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Loading: require('/app/components/Loading.vue').default,CountriesList: require('/app/components/CountriesList.vue').default,LanguagesList: require('/app/components/LanguagesList.vue').default})
